import graph from './components/graph';
import {intro} from "./components/intro";
import {aosInit} from "./components/aos";

function init() {
	graph.init();
	intro();
	aosInit();
}

init();
